<!-- app.vue or layouts/default.vue -->
<script setup lang="ts">
import { useDataStore } from "~/stores/data";

const dataStore = useDataStore();
await callOnce(() => dataStore.fetchCategories());
</script>

<template>
  <LayoutHeader />
  <slot></slot>
  <LayoutFooter />
</template>
